<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <p>1) *bold text*</p>
                      <p>2) _italic text_</p>
                      <p>3) [your text](https://freequiz.oziquz.ga)</p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <div class="custom-file custom-file-w-sm mr-2">
                        <input id="addViewChoose" type="file" class="custom-file-input"
                               accept="image/*" @change="onChoose">
                        <label class="custom-file-label border border-light" for="addViewChoose">
                          <span>Upload</span>
                        </label>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6" class="py-3">
                      <img v-if="hasImages" style="width: 300px; height: auto;" :src="baseUrl + item.image.imageUrl" alt="img">
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <Textarea v-model="item.message" rows="5" placeholder="Message"
                                :addClass="{'is-invalid': $v.item.message.$error}">Message</Textarea>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="showConfirmation">Send</b-button>
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/broadcast'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="isDeleteModal"
             :no-close-on-backdrop="true"
             centered title="Confirmation"
             @cancel="isDeleteModal = false"
             @ok="onSubmit">
      <form>
        <h3 class="text-black-50">Do you really want to send a message</h3>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { API_SERVER } from '../../constants/constants'

export default {
  name: 'BroadcastAddEditPage',
  data () {
    return {
      isDeleteModal: false,
      item: {}
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      return
    }
    this.$loading.show()
    this.axios.get('broadcast/item', {params: {id: this.$route.params.id}})
      .then(response => {
        this.item = response.data.data
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  computed: {
    pageName () {
      return 'Send Message'
    },
    hasImages () {
      return this.item.image && this.item.image.imageUrl
    },
    baseUrl () {
      return API_SERVER
    }
  },
  methods: {
    showConfirmation () {
      if (this.$v.item.$invalid) {
        this.$v.$touch()
        this.$toastr.error('Please, fill required fields')
        return
      }
      this.isDeleteModal = true
    },
    onSubmit () {
      this.$loading.show()
      let axios
      if (this.item.id) {
        axios = this.axios.put('broadcast/item', this.item)
      } else {
        axios = this.axios.post('broadcast/item', this.item)
      }
      axios.then((res) => {
        this.$loading.hide()
        if (res.data && res.data.status === 200) {
          this.$toastr.success(res.data.message)
          this.$router.push('/broadcast')
        } else {
          this.$toastr.error(res.data.message)
        }
      })
    },
    onChoose (event) {
      const formData = new FormData()
      formData.append('file', event.target.files[0])
      this.axios.post('broadcast/upload-image', formData,
        {headers: {'Content-Type': 'multipart/form-data'}}
      ).then((response) => {
        if (response.data && response.data.data) {
          const _item = Object.assign({}, this.item)
          _item.image = {
            id: response.data.data.id,
            imageUrl: response.data.data.imageUrl
          }
          this.item = _item
        }
      })
    }
  },
  validations: {
    item: {
      message: {
        required
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/broadcast/BroadcastAddEditPage.vue